import React from 'react';
import RegisterComponent from '../../components/RegisterComponent/RegisterComponent';

const Register = () => {
    return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-canvas px-4 py-10">
            <img src="/cb_logo.png" alt="ClientBloom Logo" className="mb-6 h-12" />
            <RegisterComponent />
        </div>
    );
};

export default Register;
